import BasicGraphSummary from "./Components/BasicGraphSummary";

export default BasicGraphSummary;
